function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { storeProductRulePage, storeProductRuleSave, storeProductRuleUpdate, storeProductRuleDelete } from '@/api/distributionStore';
export default {
  name: 'DistributionStoreRule',
  data: function data() {
    return {
      loading: false,
      saving: false,
      visible: false,
      rows: [],
      total: 0,
      query: {
        page: 1,
        limit: this.$constants.page.limit[0],
        keywords: ''
      },
      form: this.emptyForm(),
      rules: {
        ruleName: [{
          required: true,
          message: '请输入规格名称',
          trigger: 'blur'
        }]
      }
    };
  },
  mounted: function mounted() {
    this.load();
  },
  methods: {
    emptyForm: function emptyForm() {
      return {
        id: null,
        ruleName: '',
        items: [{
          value: '',
          details: ''
        }]
      };
    },
    parseRule: function parseRule(value) {
      try {
        var result = JSON.parse(value || '[]');
        return Array.isArray(result) ? result : [];
      } catch (e) {
        return [];
      }
    },
    formatDetails: function formatDetails(details) {
      if (!Array.isArray(details)) return '';
      return details.map(function (item) {
        return _typeof(item) === 'object' ? item.value : item;
      }).filter(Boolean).join('、');
    },
    load: function load() {
      var _this = this;
      this.loading = true;
      storeProductRulePage(this.query).then(function (res) {
        _this.rows = res.list || [];
        _this.total = Number(res.total) || 0;
      }).finally(function () {
        _this.loading = false;
      });
    },
    search: function search() {
      this.query.page = 1;
      this.load();
    },
    reset: function reset() {
      this.query.keywords = '';
      this.search();
    },
    pageChange: function pageChange(page) {
      this.query.page = page;
      this.load();
    },
    sizeChange: function sizeChange(limit) {
      this.query.limit = limit;
      this.query.page = 1;
      this.load();
    },
    openEditor: function openEditor(row) {
      var _this2 = this;
      if (!row) {
        this.form = this.emptyForm();
      } else {
        var items = this.parseRule(row.ruleValue).map(function (item) {
          return {
            value: item.value || '',
            details: _this2.formatDetails(item.detail).replace(/、/g, ',')
          };
        });
        this.form = {
          id: row.id,
          ruleName: row.ruleName,
          items: items.length ? items : [{
            value: '',
            details: ''
          }]
        };
      }
      this.visible = true;
    },
    addItem: function addItem() {
      this.form.items.push({
        value: '',
        details: ''
      });
    },
    removeItem: function removeItem(index) {
      if (this.form.items.length === 1) return this.$message.warning('至少保留一个规格项');
      this.form.items.splice(index, 1);
    },
    submit: function submit() {
      var _this3 = this;
      this.$refs.form.validate(function (valid) {
        if (!valid) return;
        var items = _this3.form.items.map(function (item) {
          return {
            value: item.value.trim(),
            detail: item.details.split(',').map(function (value) {
              return value.trim();
            }).filter(Boolean)
          };
        });
        if (items.some(function (item) {
          return !item.value || !item.detail.length;
        })) {
          _this3.$message.warning('请完整填写规格名和规格值');
          return;
        }
        var data = {
          id: _this3.form.id,
          ruleName: _this3.form.ruleName,
          ruleValue: JSON.stringify(items)
        };
        _this3.saving = true;
        var request = data.id ? storeProductRuleUpdate(data) : storeProductRuleSave(data);
        request.then(function () {
          _this3.$message.success('保存成功');
          _this3.visible = false;
          _this3.load();
        }).finally(function () {
          _this3.saving = false;
        });
      });
    },
    remove: function remove(row) {
      var _this4 = this;
      this.$modalSure('删除当前规格模板吗？').then(function () {
        return storeProductRuleDelete(row.id);
      }).then(function () {
        _this4.$message.success('删除成功');
        _this4.load();
      });
    },
    clearForm: function clearForm() {
      this.form = this.emptyForm();
      if (this.$refs.form) this.$refs.form.clearValidate();
    }
  }
};